import { render } from "./ViewArtWork.vue?vue&type=template&id=559f4762&scoped=true"
import script from "./ViewArtWork.vue?vue&type=script&lang=js"
export * from "./ViewArtWork.vue?vue&type=script&lang=js"

import "./ViewArtWork.vue?vue&type=style&index=0&id=559f4762&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559f4762"]])

export default __exports__